const data = [
    {
        id: "private-offices",
        name: "Private Offices",
        images: [
            "private-rooms/p-img7.jpg",
            "private-rooms/p-img14.jpg",
            "private-rooms/p-img16.jpg",
            "private-rooms/p-img20.jpg",
            "private-rooms/p-img22.jpg"
        ]
    },

    {
        id: "meeting-rooms",
        name: "Meeting Rooms",
        images: [
            "meeting-rooms/m-img17.jpg",
            "meeting-rooms/m-img18.jpg",
            "meeting-rooms/m-img19.jpg",
            "meeting-rooms/m-img21.jpg",
            "meeting-rooms/m-img22.jpg"
        ]
    },

    {
        id: "dedicated-desks",
        name: "Dedicated Desks",
        images: [
            "dedicated-desk/d-d-img5.jpg",
            "dedicated-desk/d-d-img6.jpg",
            "dedicated-desk/d-d-img8.jpg",
            "dedicated-desk/d-d-img15.jpg",
            "dedicated-desk/d-d-img22.jpg"
        ]
    },

    {
        id: "flexi-desks",
        name: "Flexi Desks",
        images: [
            "flexi-desk/f-d-img1.jpg",
            "flexi-desk/f-d-img2.jpg",
            "flexi-desk/f-d-img9.jpg",
            "flexi-desk/f-d-img10.jpg",
            "flexi-desk/f-d-img11.jpg",
            "flexi-desk/f-d-img12.jpg",
            "flexi-desk/f-d-img13.jpg"
        ]
    },
    {
        id: "coming-soon",
        name: "Coming Soon",
        images: [
            "dedicated-desk/d-d-img5.jpg",
            "dedicated-desk/d-d-img6.jpg",
            "dedicated-desk/d-d-img8.jpg",
            "dedicated-desk/d-d-img15.jpg",
            "dedicated-desk/d-d-img22.jpg"
        ]
    },
];


const location_data = [
    {
        id: "location_1",
        location_name: "Bermondsey, London new 1",
        list_content: [
            {
                name: "Bermondsey, London 1",
                img: "img_1.jpg",
                address: "16 Tudor Gardens, London SW13 0JS",
                full_discription: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinction",
                working_days: "5 Days (Monday - Friday)",
                opening_time: "09:00 AM - 06:30 PM",
                map_url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.670119483452!2d-0.08154908408735735!3d51.50092081899765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760344f66c3b3b%3A0x14e8939f1b1dd839!2sMaltings%20place%2C%20169%20Tower%20Bridge%20Rd%2C%20London%20SE1%203LJ%2C%20UK!5e0!3m2!1sen!2sin!4v1652771976116!5m2!1sen!2sin",
                gallery: ["d-d-img5.jpg", "d-d-img5.jpg", "d-d-img5.jpg", "d-d-img5.jpg", "d-d-img5.jpg"],
                amenities: ["High Speed Internet", "Printer", "Phone Booths", "Recreational Area  + 20 Amenties", "Enhanced Cleaning Services"],
                roomtype: [
                    { room_name: "Meeting Room", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "meeting-rooms", image: "img_1.jpg" },

                    { room_name: "Private Office", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "private-office", image: "img_1.jpg" },

                    { room_name: "Dedicated Desk", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "dedicated-desk", image: "img_1.jpg" },

                    { room_name: "Flexi Desk", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "flexi-desk", image: "img_1.jpg" }
                ]
            }
        ],

    },

    {
        id: "location_2",
        location_name: "Bermondsey, London new 2",
        list_content: [
            {
                name: "Bermondsey, London 2",
                img: "img_1.jpg",
                address: "16 Tudor Gardens, London SW13 0JS",
                full_discription: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinction",
                working_days: "5 Days (Monday - Friday)",
                opening_time: "09:00 AM - 06:30 PM",
                map_url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.670119483452!2d-0.08154908408735735!3d51.50092081899765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760344f66c3b3b%3A0x14e8939f1b1dd839!2sMaltings%20place%2C%20169%20Tower%20Bridge%20Rd%2C%20London%20SE1%203LJ%2C%20UK!5e0!3m2!1sen!2sin!4v1652771976116!5m2!1sen!2sin",
                gallery: ["d-d-img5.jpg", "d-d-img5.jpg", "d-d-img5.jpg", "d-d-img5.jpg", "d-d-img5.jpg"],
                amenities: ["High Speed Internet", "Printer", "Phone Booths", "Recreational Area  + 20 Amenties", "Enhanced Cleaning Services"],
                roomtype: [
                    { room_name: "Meeting Room", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "meeting-rooms", image: "img_1.jpg" },

                    { room_name: "Private Office", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "private-office", image: "img_1.jpg" },

                    { room_name: "Dedicated Desk", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "dedicated-desk", image: "img_1.jpg" },

                    { room_name: "Flexi Desk", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "flexi-desk", image: "img_1.jpg" }
                ]
            }
        ],

    },

    {
        id: "location_3",
        location_name: "Bermondsey, London new 3",
        list_content: [
            {
                name: "Bermondsey, London 3",
                img: "img_1.jpg",
                address: "16 Tudor Gardens, London SW13 0JS",
                full_discription: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinction",
                working_days: "5 Days (Monday - Friday)",
                opening_time: "09:00 AM - 06:30 PM",
                map_url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.670119483452!2d-0.08154908408735735!3d51.50092081899765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760344f66c3b3b%3A0x14e8939f1b1dd839!2sMaltings%20place%2C%20169%20Tower%20Bridge%20Rd%2C%20London%20SE1%203LJ%2C%20UK!5e0!3m2!1sen!2sin!4v1652771976116!5m2!1sen!2sin",
                gallery: ["d-d-img5.jpg", "d-d-img5.jpg", "d-d-img5.jpg", "d-d-img5.jpg", "d-d-img5.jpg"],
                amenities: ["High Speed Internet", "Printer", "Phone Booths", "Recreational Area  + 20 Amenties", "Enhanced Cleaning Services"],
                roomtype: [
                    { room_name: "Meeting Room", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "meeting-rooms", image: "img_1.jpg" },

                    { room_name: "Private Office", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "private-office", image: "img_1.jpg" },

                    { room_name: "Dedicated Desk", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "dedicated-desk", image: "img_1.jpg" },

                    { room_name: "Flexi Desk", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "flexi-desk", image: "img_1.jpg" }
                ]
            }
        ],

    },

    {
        id: "location_4",
        location_name: "Bermondsey, London new 4",
        list_content: [
            {
                name: "Bermondsey, London 4",
                img: "img_1.jpg",
                address: "16 Tudor Gardens, London SW13 0JS",
                full_discription: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinction",
                working_days: "5 Days (Monday - Friday)",
                opening_time: "09:00 AM - 06:30 PM",
                map_url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.670119483452!2d-0.08154908408735735!3d51.50092081899765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760344f66c3b3b%3A0x14e8939f1b1dd839!2sMaltings%20place%2C%20169%20Tower%20Bridge%20Rd%2C%20London%20SE1%203LJ%2C%20UK!5e0!3m2!1sen!2sin!4v1652771976116!5m2!1sen!2sin",
                gallery: ["d-d-img5.jpg", "d-d-img5.jpg", "d-d-img5.jpg", "d-d-img5.jpg", "d-d-img5.jpg"],
                amenities: ["High Speed Internet", "Printer", "Phone Booths", "Recreational Area  + 20 Amenties", "Enhanced Cleaning Services"],
                roomtype: [
                    { room_name: "Meeting Room", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "meeting-rooms", image: "img_1.jpg" },

                    { room_name: "Private Office", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "private-office", image: "img_1.jpg" },

                    { room_name: "Dedicated Desk", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "dedicated-desk", image: "img_1.jpg" },

                    { room_name: "Flexi Desk", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "flexi-desk", image: "img_1.jpg" }
                ]
            }
        ],

    },

    {
        id: "location_5",
        location_name: "Bermondsey, London new 5",
        list_content: [
            {
                name: "Bermondsey, London 5",
                img: "img_1.jpg",
                address: "16 Tudor Gardens, London SW13 0JS",
                full_discription: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinction",
                working_days: "5 Days (Monday - Friday)",
                opening_time: "09:00 AM - 06:30 PM",
                map_url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.670119483452!2d-0.08154908408735735!3d51.50092081899765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760344f66c3b3b%3A0x14e8939f1b1dd839!2sMaltings%20place%2C%20169%20Tower%20Bridge%20Rd%2C%20London%20SE1%203LJ%2C%20UK!5e0!3m2!1sen!2sin!4v1652771976116!5m2!1sen!2sin",
                gallery: ["d-d-img5.jpg", "d-d-img5.jpg", "d-d-img5.jpg", "d-d-img5.jpg", "d-d-img5.jpg"],
                amenities: ["High Speed Internet", "Printer", "Phone Booths", "Recreational Area  + 20 Amenties", "Enhanced Cleaning Services"],
                roomtype: [
                    { room_name: "Meeting Room", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "meeting-rooms", image: "img_1.jpg" },

                    { room_name: "Private Office", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "private-office", image: "img_1.jpg" },

                    { room_name: "Dedicated Desk", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "dedicated-desk", image: "img_1.jpg" },

                    { room_name: "Flexi Desk", para: "A space usually set aside for people to get together, often informally to hold meetings, for issues to be discussed, priorities set and decisions made", url_name: "flexi-desk", image: "img_1.jpg" }
                ]
            }
        ],

    },
];


const bookingType = [
    {
        id: "meeting-rooms",
        name: "Meeting Rooms",
        url: "meeting_room",
        //price: "Free reservation",
        price: "",
        img: "bk-meeting-rooms.jpg",
    },

    {
        id: "private-office",
        name: "Private Office",
        url: "private_office",
        price: "",
        img: "bk-private-office.jpg",
    },

    /* {
        id: "dedicated-desk",
        name: "Dedicated Desk",
        url: "dedicated-desk",
        price: "",
        img: "bk-dedicated-desk.jpg",
    },

    {
        id: "flexible-desk",
        name: "Flexible Desk",
        url: "flexible_desk",
        price: "",
        img: "bk-flexible-desk.jpg",
    }, */
];

export { data, location_data, bookingType };